/**
 * @generated SignedSource<<c86ab6aba5c38e33e67c96cbf663c8f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespPriceTiles_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespTradeFreeShippingPromoTile_viewer">;
  readonly " $fragmentType": "SbRespPriceTiles_viewer";
};
export type SbRespPriceTiles_viewer$key = {
  readonly " $data"?: SbRespPriceTiles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespPriceTiles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespPriceTiles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespTradeFreeShippingPromoTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4760440d96086d66ea05dd0069d3c513";

export default node;
